module.exports = __webpack_public_path__ + "static/media/coins-default.f972744e.png";